import { render, staticRenderFns } from "./BigUnmuteButton.vue?vue&type=template&id=363b8fb7&lang=pug&"
import script from "./BigUnmuteButton.vue?vue&type=script&lang=ts&"
export * from "./BigUnmuteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports